<template>
  <main class="dn-margin-1">
    <div class="cover" v-on:click="operateVideo"></div>
    <video id="video"
      ref="dnvideo"
      class="dn-video-wh object-fit-contain video"
      :src="videoSrc"
      loop="loop"
      autoplay
      playsinline="true"
      controls="controls"
      x5-video-player-type="h5"
      x5-video-orientation="landscape"
      controlsList="nodownload  noplaybackrate"
      disablePictureInPicture
      v-bind:style="{width: width + 'px'}">
    </video>

    <div class="row-2" style="padding-top: 0.5rem;" v-on:click="showmodal2">
        <pre class="dn-font-14" v-bind:class="{tz:tzactive}" v-on:click="showImage">{{videoContent}}</pre>
         <pre class="dn-font-14">{{videoContent2}}</pre>
    </div>

    <div class="swiper mySwiper">
      <div style="text-align: left;margin-top: -12px;">
        <p class="dn-font-14" v-bind:style="{display: pjms}">*本步骤可能用到的配件</p>
      </div>
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(site, index) in pj" :key="index">
          <img :name=site.pjname :src=site.pjsrc v-on:click="showmodalF" style="border-radius:10px;"/>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <div class="modal" v-show="showModal">
      <div class="modal-dialog" style="width:900px;height:400px;">
        <div class="modal-content">
          <div class="modal-header" style="padding:0.25rem 1.25rem 0.25rem 1.25rem;">
            <h5 class="modal-title">{{modalname}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closemodalF">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="height:300px;">
            <img :src='modalimgsrc' class='carousel-inner img-responsive img-rounded' style='width:100%;height:100%;' 
            v-bind:style="{display: imgDisplay}"
            />
            <video
            v-bind:style="{display: videoDisplay}"
            id="video"
            ref="dnvideo2"
            class="dn-video-wh object-fit-contain video"
            :src="tzvideosrc"
            loop="loop"
            controls="controls"
            playsinline="true"
            x5-video-player-type="h5"
            x5-video-orientation="landscape"
            controlsList="nodownload  noplaybackrate"
            disablePictureInPicture
            style="width:22rem;">
            </video>
            <div>
              {{tzcontent}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Swiper from 'swiper'
export default {
  name: 'model1',
  components: {
    Swiper
  },
  data () {
    return {
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      // topage
      toPage: this.$route.query.toPage,
      // video
      videoSrc: '',
      videoContent: '',
      videoContent2: '',
      pj: '',
      // modal
      showModal: false,
      modalimgsrc: '',
      modalname: '',
      // pjms
      pjms: 'none',
      // modal
      tzvideosrc: '',
      tzcontent: '',
      imgDisplay: 'block',
      videoDisplay: 'none',
      //
      tzactive: false
    }
  },
  methods: {
    // dryer1
    showImage: function (event) {
      if (this.toPage === 'dryer1') {
        this.$router.push('/czdb')
      }
    },
    showmodalF: function (event) {
      this.imgDisplay = 'block'
      this.videoDisplay = 'none'
      this.showModal = true
      this.modalimgsrc = event.srcElement.currentSrc
      this.modalname = event.srcElement.name
    },
    operateVideo: function (event) {
      if (this.$refs.dnvideo.paused) {
        this.$refs.dnvideo.play()
      } else {
        this.$refs.dnvideo.pause()
      }
    },
    showmodal2: function (event) {
      this.imgDisplay = 'none'
      this.videoDisplay = 'block'
      this.$refs.dnvideo.pause()
      if (this.tzvideosrc !== undefined) {
        this.showModal = true
        this.$refs.dnvideo2.play()
      }
    },
    closemodalF: function (event) {
      this.showModal = false
      if (this.$refs.dnvideo2.paused) {
        // nothing to do
      } else {
        this.$refs.dnvideo2.pause()
      }
    }
  },
  mounted () {
    // 页面高度 宽度变化
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        this.height = window.screenHeight

        window.screenWidth = document.body.clientWidth
        this.width = window.screenWidth
      })()
    },
    new Swiper ('.swiper', {
      loop: false, // 循环模式选项
      slidesPerView: 4,
      spaceBetween: 5,
      initialSlide: 0,
      pagination: {
        el: '.swiper-pagination',
      },
    })
  },
  watch: {
    height (val) {
      this.height = val
    },
    width (val) {
      this.width = val
    },
    toPage: {
      handler: function (newValue, oldValue) {
        this.tzactive = false
        if (newValue !== undefined) {
          this.pjms = 'none'
          this.pj = this.$global.filter(item => item.page === newValue)[0].pj
          this.videoSrc = this.$global.filter(item => item.page === newValue)[0].videoSrc
          this.videoContent = this.$global.filter(item => item.page === newValue)[0].videoContent
          this.videoContent2 = this.$global.filter(item => item.page === newValue)[0].videoContent2

          // 跳转视频及描述
          this.tzvideosrc = this.$global.filter(item => item.page === newValue)[0].tzvideosrc
          this.tzcontent = this.$global.filter(item => item.page === newValue)[0].tzcontent

          if (this.pj.length > 0) {
            this.pjms = 'block'
          }

          if (this.tzvideosrc !== undefined) {
            this.tzactive = true
          }
        }

        if (newValue === 'dryer1') {
          this.tzactive = true
        }
      },
      immediate: true
    },
    $route (to, from) {
      this.toPage = to.query.toPage
    }
  }
}
</script>
<style scoped>
.tz {
  color: #ffc8aa;
  font-weight: bold;
}

.swiper {
  width: 22rem;
  padding-top: 20px;
  padding-bottom: 20px;
  --swiper-navigation-color: gray;/* 单独设置按钮颜色 */
  --swiper-navigation-size: 25px;/* 设置按钮大小 */
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 84.25px;
  height: 84.25px;
  margin-right: 5px;
}

.swiper-slide img {
  display: block;
  width: 100%;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%!;(MISSING)
  height: 100%!;(MISSING)
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/model1.vue